// extracted by mini-css-extract-plugin
module.exports = {"linkClick":"_1Dc0tqBc"};